import axios from 'axios';
import {getLookupValueMaster} from "../server/Api";

export const getLookupUtils = async (lookup_mst_id) => {

  try {
    const response = await axios.get(`${getLookupValueMaster()}/${lookup_mst_id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching lookup data:', error);
    throw error;
  }
};

